export const LIST_NOTIFICATIONS_PAGINATION = {
  page: 1,
  itemsPerPage: 25
};